export default __webpack_public_path__ + "static/media/bestseller3.9c3f1f86.png";